import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import AboutUs from '../views/AboutUs.vue'
import Dashboard from '../views/Dashboard.vue'
import Projects from '../views/Projects.vue'
import Registration from '../views/Registration.vue'
import ResetPwd from '../views/ResetPwd.vue'
import MySettings from '../views/MySettings.vue'
import NewProject from '../views/Newproject.vue'
import ContactUs from '../views/ContactUs.vue'
import Terms from '../views/Terms.vue'
import Admin from '../views/Admin.vue'
import Report from '../views/report.vue'
import projectDetails from '../views/projectDetails.vue'
import TermsandCondition from '../views/TermsandCondition.vue'
import Meta from 'vue-meta'

import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(DatetimePicker)
Vue.use(VueRouter)
Vue.use(Meta)
let publicRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/about',
    name: 'About',
    component: AboutUs,
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
  },
  {
    path: '/reset-pwd',
    name: 'ResetPwd',
    component: ResetPwd,
  },
  {
    path: '/contactus',
    name: 'contactUs',
    component: ContactUs
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  },
  {
    path: '/projectDetails/:project',
    name: 'projectDetails',
    component: projectDetails
  },
  {
    path: '/report/:id',
    name: 'report',
    component: Report
  },
  {
    path: '/termsandcondition',
    name: 'TermsandCondition',
    component: TermsandCondition
  }
];

publicRoutes = publicRoutes.map(route => {
  return { ...route, meta: { public: true } }
});

let privateRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/settings',
    name: 'MySettings',
    component: MySettings
  },
  {
    path: '/newProject',
    name: 'NewProject',
    component: NewProject
  }
]

privateRoutes = privateRoutes.map(route => {
  return { ...route, meta: { public: false, admin: false } }
});

let adminRoutes = [
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
  },
];

adminRoutes = adminRoutes.map(route => {
  return { ...route, meta: { public: false, admin: true } };
})

const routes = publicRoutes.concat(privateRoutes).concat(adminRoutes);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
  }
});

const isAuthenticated = () => {
  return window.localStorage.getItem("token") ? true : false;
};

const isAdmin = () => {
  return isAuthenticated() && window.localStorage.getItem("admin") === 'true';
};

router.beforeResolve((to, from, next) => {
  const authenticated = isAuthenticated();
  const admin = isAdmin();
  const isPublic = to.matched.some(record => record.meta.public);
  const adminRoute = to.matched.some(record => record.meta.admin);
  if ((!isPublic && !authenticated && to.name !== 'Login') || (adminRoute && !admin && to.name !== 'Login')) {
    // next({
    //   path: '/login',
    //   query: { redirect: to.fullPath }
    // });
    window.location.href = '/login';
  } else if (authenticated && to.name === 'Login') {
    next({
      path: '/dashboard',
    });
  } else {
    next();
  }
});

router.afterEach(() => {
  //NProgress.done()
  //App.loading = false
});

export default router;
